import { Channel } from 'src/app/channel/model/channel';
import { Organization } from 'src/app/core/model/organization';
import { EmailTemplateEdit } from 'src/app/email-template/model/email-template';
export class PatientImportEdit
{
    public id = null;
    public version = 0;
    public name = '';
    public description = '';
    public locked = false;
    public importStage = '';
    public inviteValidDays = 30;
    public sendInvite = false;
    public inviteTemplate: EmailTemplateEdit;
    public inviteSendOn: Date;
    public validationErrors = false;
    public automaticImport = false;
    public automaticDiscardOnError = false;
    public importDocument: any;
    public parsingErrors = false;
    public parsingErrorMessage = '';
    public channel: Channel;
    public referralChannel: Channel;
    public pcpCreationLevel = 'PATIENT';
    public contactCreationLevel = 'PATIENT';
    public organization: Organization;
    public subjectIdentifiers = '';
    public skipNonRequiredFields = false;
}

export interface PatientImportList
{
    id: number;
    name: string;
    description: string;
    lastModifiedBy: string;
    lastModifiedDate: Date;
}
